import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation();
  return <>{t('common.label.pageNotFound')}</>;
};

export default NotFoundPage;
